<div class="stepper-body">
    <div class="body-title">
        <span>What is your current address?</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ CurrentAddressInputs.Address1 }}</mat-label>
                        <input matInput [formControlName]="CurrentAddressInputs.Address1" [required]="true" />
                        <mat-error *ngIf="formGroup.get(CurrentAddressInputs.Address1)?.touched
                                        && formGroup.get(CurrentAddressInputs.Address1)?.hasError('required')">
                            {{ CurrentAddressInputs.Address1 }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ CurrentAddressInputs.City }}</mat-label>
                        <input matInput [formControlName]="CurrentAddressInputs.City" [required]="true" />
                        <mat-error *ngIf="formGroup.get(CurrentAddressInputs.City)?.touched
                                        && formGroup.get(CurrentAddressInputs.City)?.hasError('required')">
                            {{ CurrentAddressInputs.City }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="input-container">
                    <lgv-state-dropdown [control]="formGroup.get(CurrentAddressInputs.State)" label="State"
                        [required]="true"></lgv-state-dropdown>
                </div>
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ CurrentAddressInputs.Zip }}</mat-label>
                        <input matInput [formControlName]="CurrentAddressInputs.Zip" [required]="true" />
                        <mat-error *ngIf="formGroup.get(CurrentAddressInputs.Zip)?.touched
                                        && formGroup.get(CurrentAddressInputs.Zip)?.hasError('required')">
                            {{ CurrentAddressInputs.Zip }} is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>